import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CoreModule } from "../core/core.module";
import { RouterModule } from "@angular/router";
import { ExitSurveyListComponent } from "./exit-survey-list/exit-survey-list.component";
import { ExitSurveyService } from "./services/exit-survey.service";
import { ExitSurveyDetailsComponent } from "./exit-survey-details/exit-survey-details.component";
import { ExitSurveyStatisticsComponent } from "./exit-survey-list/exit-survey-statistics/exit-survey-statistics.component";
import { CancellationsStatisticsComponent } from "./exit-survey-list/cancellations-statistics/cancellations-statistics.component";

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    RouterModule
  ],
  exports: [ExitSurveyListComponent, ExitSurveyDetailsComponent],
  providers: [ExitSurveyService],
  declarations: [ExitSurveyListComponent, ExitSurveyStatisticsComponent, ExitSurveyDetailsComponent, CancellationsStatisticsComponent],
})
export class ExitSurveyModule { }



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey.module.ts